import(/* webpackMode: "eager", webpackExports: ["Tabs","TabItem"] */ "/home/runner/work/pandahub-website-nextjs/pandahub-website-nextjs/components/common/tab-view.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/pandahub-website-nextjs/pandahub-website-nextjs/node_modules/next/dist/client/image-component.js");
